/* eslint-disable no-unused-vars */
import { observer } from "mobx-react-lite";
import { useStore } from "../../../root-store-context";
import * as React from "react";
import { DataTypeTableUpload } from "./UploadApp";
import { Button, Checkbox, Select, Table, TableColumnsType } from "antd";
import { RcFile } from "antd/es/upload";
import { MailJobFile } from "../../../stores/AppStore/ApplicationStore";
import { useCamIsMobile } from "hooks/useCamIsMobile";

const filterOption = (input: any, option: any) =>
  (option?.label ?? "").toLowerCase().includes(input?.toLowerCase());

const filterSort = (optionA: any, optionB: any) =>
  (optionA?.label ?? "")
    .toLowerCase()
    .localeCompare((optionB?.label ?? "").toLowerCase());

const RenderSelectedCommunity = observer((props: DataTypeTableUpload) => {
  const { applicationStore } = useStore();
  return (
    <Select
      data-testid={`cam-community-select-${props.keyData}`}
      showSearch
      style={{ width: "100%" }}
      value={props.fileInfo.communityKey}
      placeholder="Search to Property"
      optionFilterProp="children"
      loading={applicationStore.isLoadCommunitiesData}
      disabled={applicationStore.isLoadCommunitiesData}
      filterOption={filterOption}
      filterSort={filterSort}
      onChange={(value) => {
        applicationStore.getCommunitiesData(
          value,
          undefined,
          props.keyData.toString()
        );
        applicationStore.setSelectedFileData(props.keyData.toString(), {
          communityKey: value,
          account: undefined,
        });
      }}
      options={
        applicationStore.communities?.map((_) => ({
          label: _.titleInDropdown,
          value: _.id,
        })) || []
      }
    />
  );
});

const RenderSelectedAccount = observer((props: DataTypeTableUpload) => {
  const { applicationStore } = useStore();
  const options = applicationStore.communitiesData.find(
    (_) => _.communitiesId === props.fileInfo.communityKey
  )?.accounts;

  return (
    <Select
      data-testid={`cam-account-select-${props.keyData}`}
      showSearch
      style={{ width: "100%" }}
      value={
        props.fileInfo.account != null
          ? String(props.fileInfo.account)
          : undefined
      }
      placeholder="Search to Account Number"
      optionFilterProp="children"
      loading={applicationStore.isLoadCommunitiesData}
      disabled={applicationStore.isLoadCommunitiesData}
      filterOption={filterOption}
      filterSort={filterSort}
      onChange={(value) => {
        applicationStore.setSelectedFileData(props.keyData.toString(), {
          account: value,
        });
      }}
      options={
        options?.map((_) => ({
          label: _.item1,
          value: _.item2,
        })) || []
      }
    />
  );
});

const RenderSelectedAddress = observer((props: DataTypeTableUpload) => {
  const { applicationStore } = useStore();
  const options = applicationStore.communitiesData.find(
    (_) => _.communitiesId === props.fileInfo.communityKey
  )?.address;

  return (
    <Select
      data-testid={`cam-address-select-${props.keyData}`}
      showSearch
      style={{ width: "100%" }}
      value={
        props.fileInfo.account != null
          ? String(props.fileInfo.account)
          : undefined
      }
      placeholder="Search to Address"
      optionFilterProp="children"
      loading={applicationStore.isLoadCommunitiesData}
      disabled={applicationStore.isLoadCommunitiesData}
      filterOption={filterOption}
      filterSort={filterSort}
      onChange={(value) => {
        applicationStore.setSelectedFileData(props.keyData.toString(), {
          account: value,
        });
      }}
      options={
        options?.map((_) => ({
          label: _.item1,
          value: _.item2,
        })) || []
      }
    />
  );
});

const RenderSelectedName = observer((props: DataTypeTableUpload) => {
  const { applicationStore } = useStore();
  const options = applicationStore.communitiesData.find(
    (_) => _.communitiesId === props.fileInfo.communityKey
  )?.names;

  return (
    <Select
      data-testid={`cam-name-select-${props.keyData}`}
      showSearch
      style={{ width: "100%" }}
      value={
        props.fileInfo.account != null
          ? String(props.fileInfo.account)
          : undefined
      }
      placeholder="Search to Name"
      optionFilterProp="children"
      loading={applicationStore.isLoadCommunitiesData}
      disabled={applicationStore.isLoadCommunitiesData}
      filterOption={filterOption}
      filterSort={filterSort}
      onChange={(value) => {
        applicationStore.setSelectedFileData(props.keyData.toString(), {
          account: value,
        });
      }}
      options={
        options?.map((_) => ({
          label: _.item1,
          value: _.item2,
        })) || []
      }
    />
  );
});

export const UploadList = observer(() => {
  const { applicationStore, modalViewerStore } = useStore();
  const isMobile = useCamIsMobile();

  const openViewFile = (file: RcFile) => {
    const blob = new Blob([file], { type: "application/pdf" });
    const fileURL = URL.createObjectURL(blob);
    modalViewerStore.openFileByUrl(fileURL, "Recipient Info.pdf");
  };

  const handleCardSelect = (checked: boolean, keyData: string) => {
    const current = applicationStore.selectedFiles;
    if (checked) {
      applicationStore.setSelectedFiles([...current, keyData]);
    } else {
      applicationStore.setSelectedFiles(current.filter((k) => k !== keyData));
    }
  };

  const getDataTypeGeneral = (_: MailJobFile): DataTypeTableUpload => ({
    key: _.guid,
    keyData: _.guid,
    fileName: _.name,
    file: _.file,
    fileInfo: _.fileInfo,
  });

  const data =
    applicationStore.mailJob.files?.map((_) => getDataTypeGeneral(_)) || [];

  const totalFiles = data.length;
  const allSelected = data.length > 0 && data.every((r) =>
    applicationStore.selectedFiles.includes(r.keyData.toString())
  );
  const someSelected = data.some((r) =>
    applicationStore.selectedFiles.includes(r.keyData.toString())
  );

  /* ════════════════════════════════════
     MOBILE
  ════════════════════════════════════ */
  if (isMobile) {
    return (
      <div className="cam__upload-cards">
        {data.map((record) => {
          const isSelected = applicationStore.selectedFiles.includes(
            record.keyData.toString()
          );
          return (
            <UploadCard
              key={record.key.toString()}
              record={record}
              isSelected={isSelected}
              onSelect={handleCardSelect}
              onOpenFile={openViewFile}
            >
              <div className="cam__upload-card-fields">
                <div className="cam__upload-card-field">
                  <label className="cam__upload-card-label">Property</label>
                  <RenderSelectedCommunity key={record.key} keyData={record.keyData} fileInfo={record.fileInfo} fileName={record.fileName} file={record.file} />
                </div>
                <div className="cam__upload-card-field">
                  <label className="cam__upload-card-label">Account Number</label>
                  <RenderSelectedAccount key={record.key} keyData={record.keyData} fileInfo={record.fileInfo} fileName={record.fileName} file={record.file} />
                </div>
                <div className="cam__upload-card-field">
                  <label className="cam__upload-card-label">Address</label>
                  <RenderSelectedAddress key={record.key} keyData={record.keyData} fileInfo={record.fileInfo} fileName={record.fileName} file={record.file} />
                </div>
                <div className="cam__upload-card-field">
                  <label className="cam__upload-card-label">Name</label>
                  <RenderSelectedName key={record.key} keyData={record.keyData} fileInfo={record.fileInfo} fileName={record.fileName} file={record.file} />
                </div>
              </div>
            </UploadCard>
          );
        })}
      </div>
    );
  }

  /* ════════════════════════════════════
     DESKTOP
  ════════════════════════════════════ */
  const columns: TableColumnsType<DataTypeTableUpload> = [
    {
      title: (
        <div style={{ display: "flex", alignItems: "center", gap: 6, whiteSpace: "nowrap" }}>
          <Checkbox
            checked={allSelected}
            indeterminate={someSelected && !allSelected}
            onChange={(e) => {
              if (e.target.checked) {
                applicationStore.setSelectedFiles(data.map((r) => r.keyData.toString()));
              } else {
                applicationStore.setSelectedFiles([]);
              }
            }}
          />
          <span style={{ fontSize: 12, fontWeight: 600 }}>Select All</span>
        </div>
      ),
      dataIndex: "select",
      width: 90,
      align: "center" as const,
      render: (_: any, record: DataTypeTableUpload) => (
        <Checkbox
          checked={applicationStore.selectedFiles.includes(record.keyData.toString())}
          onChange={(e) => handleCardSelect(e.target.checked, record.keyData.toString())}
        />
      ),
    },
    {
      title: "File",
      dataIndex: "fileName",
      width: 200,
      ellipsis: true,
      render: (text: string, record: DataTypeTableUpload) => (
        <Button
          type="link"
          onClick={() => openViewFile(record.file)}
          style={{
            maxWidth: "100%",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            display: "block",
          }}
        >
          {text}
        </Button>
      ),
    },
    {
      title: "Property",
      dataIndex: "fileInfo",
      width: 250,
      ellipsis: true,
      render: (text: string, record: DataTypeTableUpload) => (
        <RenderSelectedCommunity
          key={record.key}
          keyData={record.keyData}
          fileInfo={record.fileInfo}
          fileName={record.fileName}
          file={record.file}
        />
      ),
    },
    {
      title: "Account Number",
      dataIndex: "fileInfo",
      width: 150,
      ellipsis: true,
      render: (text: string, record: DataTypeTableUpload) => (
        <RenderSelectedAccount
          key={record.key}
          keyData={record.keyData}
          fileInfo={record.fileInfo}
          fileName={record.fileName}
          file={record.file}
        />
      ),
    },
    {
      title: "Address",
      dataIndex: "fileInfo",
      width: 150,
      ellipsis: true,
      render: (text: string, record: DataTypeTableUpload) => (
        <RenderSelectedAddress
          key={record.key}
          keyData={record.keyData}
          fileInfo={record.fileInfo}
          fileName={record.fileName}
          file={record.file}
        />
      ),
    },
    {
      title: "Name",
      dataIndex: "fileInfo",
      width: 150,
      ellipsis: true,
      render: (text: string, record: DataTypeTableUpload) => (
        <RenderSelectedName
          key={record.key}
          keyData={record.keyData}
          fileInfo={record.fileInfo}
          fileName={record.fileName}
          file={record.file}
        />
      ),
    },
  ];

  const columnsAligned = columns.map((col) => ({
    ...col,
    onCell: () => ({ style: { verticalAlign: "middle" as const } }),
    onHeaderCell: () => ({ style: { verticalAlign: "middle" as const } }),
  }));

  return (
    <div style={{ width: "100%", overflowX: "auto" }}>
      <Table
        pagination={false}
        columns={columnsAligned}
        dataSource={data}
        scroll={{ x: 990 }}
        style={{ tableLayout: "fixed" }}
      />
    </div>
  );
});

const UploadCard = ({
  record,
  isSelected,
  onSelect,
  onOpenFile,
  children,
}: {
  record: DataTypeTableUpload;
  isSelected: boolean;
  onSelect: (checked: boolean, keyData: string) => void;
  onOpenFile: (file: RcFile) => void;
  children?: React.ReactNode;
}) => {
  return (
    <div
      className={`cam__upload-card ${isSelected ? "cam__upload-card--selected" : ""}`}
    >
      <div className="cam__upload-card-header">
        <Checkbox
          checked={isSelected}
          aria-label={`Select file ${record.fileName}`}
          onChange={(e) => onSelect(e.target.checked, record.keyData.toString())}
        />
        <Button
          type="link"
          className="cam__upload-card-filename"
          onClick={() => onOpenFile(record.file)}
        >
          {record.fileName}
        </Button>
      </div>
      {children}
    </div>
  );
};
